import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class DespachoService {

  apiService: any;

  constructor() { }

  despachar(vm, dados) {

    dados.data_andamento = vm.dataHoraDoSistema;

    if (vm.labelTipoEncaminhamento == ' ') {
      vm.toastr.warning('Selecione o destino do despacho; AGENTE ou UNIDADE', 'Atenção');
      vm.exibirSpinnerListaDeAndamento = false;
      vm.retorno = false;
      return false;
    } else if (dados.despacho_tipo == '') {
      vm.toastr.warning('Selecione um TIPO DE DESPACHO', 'Atenção');
      vm.exibirSpinnerListaDeAndamento = false;
      vm.retorno = false;
      return false;
    } else if (vm.labelTipoEncaminhamento === 'UNIDADE') {

      vm.unidades.forEach(objeto => {
        if (objeto.id == dados.unidades_id) {
          dados.unidades_nome = objeto.sigla;
        }
      })
    }

    else if (vm.labelTipoEncaminhamento == 'AGENTE') {
      if (dados.matricula) {
        dados.agentes_id = vm.agenteFormularioProvidencia.id;
        dados.unidades_id = vm.agenteFormularioProvidencia.unidade_id;
      } else {
        vm.toastr.warning('O Campo matricula não pode ser vazio', 'Atenção');
        vm.exibirSpinnerListaDeAndamento = false;
        return false;
      }
    }

    return true;
  }
}


// WEBPACK FOOTER //
// ./src/app/services/despacho.service.ts